import { useFeatureAttachments } from "entity-app/hooks/feature-attachments";
import "./feature-attachments.scss";
import { Button, message, Tooltip } from "antd";
import { getFileDownloadURL } from "services/file-mgmt";
import { downloadFileFromS3andOpenInNewTab } from "utils/utils";
import { useHistory, useParams } from "react-router";
import { useSubmmittialDetails } from "pages/submittal-details/new-submittal-details/hook/submittal-details-hook";
import AttachmentItem from "./attachment-item";
import { EntityType, ErrorMessages, noDocumentMessage } from "../../constants";

function FeatureAttachments(props: {
  isRevisionMode?: boolean;
  featureInstanceData?: any;
  featureId: string;
  featureKey: string;
  disabled?: boolean;
  setTabIndex?: (tab: string) => void;
  featureType?: EntityType;
  setAddMore?: any;
}) {
  const {
    isRevisionMode,
    featureInstanceData,
    featureId,
    featureKey,
    disabled = false,
    setTabIndex,
    featureType,
    setAddMore
  } = props;
  const { attachments, error, loading } = useFeatureAttachments(
    featureId,
    featureKey,
    featureInstanceData?.revision
  );
  const history = useHistory();
  const { projectId } = useParams() as any;

  const { getAttachBtnDisabledMsg } = useSubmmittialDetails({
    featureInstanceData,
    isRevisionMode: isRevisionMode || false
  });

  const onAttachmentClick = async (data: any) => {
    message.success(ErrorMessages.comments.fileDownloadStarted);
    try {
      const fileDownloadURLResp: any = await getFileDownloadURL([
        data.blob_key
      ]);
      await downloadFileFromS3andOpenInNewTab(
        fileDownloadURLResp.data.success.urls[data.blob_key],
        data.file_type,
        data.file_name
      );
    } catch (ex: any) {
      // console.log("ex ", ex);
      const errorMsg: string =
        ex.response?.data?.error ||
        ex.message ||
        "Unable to download attachment";
      message.error(errorMsg);
    }
  };

  if ((loading && (!attachments || !attachments.length)) || error) {
    return null;
  }

  const addMoreBtn = (
    <Tooltip title={getAttachBtnDisabledMsg()} placement="rightBottom">
      <Button
        size="small"
        type="text"
        className="border-none pr-1"
        onClick={() => {
          if (setTabIndex) {
            setTabIndex("2");
          }
          history.push(`/project/${projectId}/submittals/${featureId}?tab=2`);
          setAddMore(true);
        }}
        title={getAttachBtnDisabledMsg()}
        disabled={disabled}
        data-testid="index-button-add-more"
      >
        <span className="add-more-btn">Add More</span>
      </Button>
    </Tooltip>
  );

  if (attachments && !attachments.length) {
    return (
      <div className="w-full h-full flex flex-col items-center justify-center text-gray-400 text-xs">
        <span className="text-xs text-neutral-400">{noDocumentMessage}</span>
        {!isRevisionMode && featureType === EntityType.Submittal && addMoreBtn}
      </div>
    );
  }

  return (
    <div className="space-y-2" data-testid="feature-attachments-root">
      <div className="flex w-full justify-between">
        {!isRevisionMode &&
          featureType === EntityType.Submittal &&
          attachments &&
          attachments.length > 0 &&
          addMoreBtn}
      </div>
      {attachments?.map((attachment: any) => (
        <AttachmentItem
          key={attachment.id}
          attachment={attachment}
          onClick={onAttachmentClick}
          data-testid="feature-attachments-item"
        />
      ))}
    </div>
  );
}

export default FeatureAttachments;
